<div class="card">
    <div class="card-header header-elements-inline">
      <h5 class="card-title">{{ !isEditMode ? 'Ajout Banquier' : 'Modifier Banquier' }}</h5>
    </div>
  
    <div class="card-body">
      <form class="form-horizontal" (ngSubmit)="submitForm()" [ngBusy]="busy" #f="ngForm">
  
        <!-- NOM -->
        <div class="row">
          <div class="form-group col-md-3">
            <label class="control-label">Nom :</label>
            <input type="text" name="name" [(ngModel)]="banker.name" class="form-control" required>
            <label *ngIf="submitted && !banker.name" class="form-text text-danger">Ce champ est requis</label>
          </div>
  
          <!-- EMAIL -->
          <div class="form-group col-md-3">
            <label class="control-label">Email :</label>
            <input type="email" name="email" [(ngModel)]="banker.email" class="form-control" required>
            <label *ngIf="submitted && !banker.email" class="form-text text-danger">Ce champ est requis</label>
          </div>
  
          <!-- TELEPHONE -->
          <div class="form-group col-md-3">
            <label class="control-label">Téléphone :</label>
            <input type="text" name="phone" [(ngModel)]="banker.phone" class="form-control">
          </div>
          <!-- bank name -->
          <div class="form-group col-md-3">
            <label class="control-label">Banque :</label>
            <input type="text" name="bank_name" [(ngModel)]="banker.bank_name" class="form-control">
          </div>
        </div>
  
        <!-- DISPONIBILITÉS -->
        <div class="row">
          <div class="col-md-12">
            <label class="control-label">Disponibilités :</label>
  
            <div *ngFor="let slot of banker.availabilities; let i = index" class="row mb-2 align-items-end">
              <div class="col-md-3">
                <input type="date" [(ngModel)]="slot.date" name="date_{{i}}" class="form-control">
              </div>
              <div class="col-md-2">
                <input type="time" class="form-control" [(ngModel)]="slot.start_time" name="start_{{i}}">
              </div>
              <div class="col-md-2">
                <input type="time" class="form-control" [(ngModel)]="slot.end_time" name="end_{{i}}">
              </div>
              <div class="col-md-3">
                <select class="form-control" [(ngModel)]="slot.interval_minutes" name="interval_{{i}}">
                  <option [value]="30">30 min</option>
                  <option [value]="45">45 min</option>
                  <option [value]="60">1 heure</option>
                </select>
              </div>
              <div class="col-md-2">
                <button type="button" class="btn btn-danger btn-sm" (click)="removeAvailability(i)">Supprimer</button>
              </div>
            </div>
  
            <button type="button" class="btn btn-outline-primary mt-2" (click)="addAvailability()">
              + Ajouter une disponibilité
            </button>
          </div>
        </div>
  
        <!-- BOUTON -->
        <div class="row mt-4">
          <div class="col-md-12 text-right">
            <button type="submit" class="btn btn-primary">
              {{ !isEditMode ? 'Ajouter' : 'Modifier' }}
            </button>
          </div>
        </div>
  
      </form>
    </div>
  </div>
  